// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableCustom_tableContainer__Taojv","nothingContainer":"TableCustom_nothingContainer__tLnVX"};